import { render } from "./Card.vue?vue&type=template&id=b5b863f6&scoped=true&bindings={\"index\":\"props\",\"shadow\":\"props\",\"clickable\":\"props\",\"back\":\"props\",\"card\":\"options\",\"unicode\":\"options\"}"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=b5b863f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5b863f6"

export default script